import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconUserHeart.tsx
const OutlinedUserHeart = ({ fill, ...props }) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: fill,
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ jsx("path", { d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" }),
		/* @__PURE__ */ jsx("path", { d: "M6 21v-2a4 4 0 0 1 4 -4h.5" }),
		/* @__PURE__ */ jsx("path", { d: "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296" })
	]
});
const componentMap = {
	outlined: OutlinedUserHeart,
	"outlined-fill": OutlinedUserHeart,
	rounded: OutlinedUserHeart,
	"rounded-fill": OutlinedUserHeart,
	sharp: OutlinedUserHeart,
	"sharp-fill": OutlinedUserHeart
};
const IconUserHeart = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconUserHeart };